import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'

const ProductDetails = ({ details, productID, t }) => (
  <React.Fragment>
    <span
      className={clsx('pdp__product-details', Typo.body2)}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: details }}
    />
    <span className={clsx('product-style', Typo.subtitle2)}>
      {hasLocizeTranslation(t, 'Style', 'Style')} #{productID}
    </span>
  </React.Fragment>
)

ProductDetails.propTypes = {
  details: PropTypes.string.isRequired,
  productID: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(ProductDetails)
